<template>
  <div class="mt-4 mb-1">
    <div v-if="listData.length > 0">
        <table class="table">
            <thead>
            <tr class="row m-0">
                <th class="col-sm-6">Název</th>
                <th class="col-sm-1">Velikost</th>
                <th class="col-sm-2">Datum</th>
                <th class="col-sm-2">Nahrál</th>
                <th class="col-sm-1"></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(document, index) in listData" class="card-text">
                <tr class="row m-0" :data-testid="'document-' + document.id">
                    <td class="col-sm-6">
                      <a :href="setting.hostname + 'document/' + document.id + '/view'" target="_blank" :data-testid="'document-view-' + document.id">{{ document.original_file_name }}</a> |
                      <a :href="setting.hostname + 'document/' + document.id +'/save'" target="_blank" :data-testid="'document-download-' + document.id">stáhnout</a>
                    </td>
                    <td class="col-sm-1">
                        {{ document.file_size_nicely}}
                    </td>
                    <td class="col-sm-2">
                        {{ document.file_date }}
                    </td>
                    <td class="col-sm-2">
                        {{ document.uploaded_by ? document.uploaded_by.fullname : '' }}
                    </td>
                    <td class="col-sm-1">
                      <button class="btn btn-xs btn-danger" @click="deleteDocument(document.id)" :data-testid="'document-delete-' + document.id"><i class="fa fa-trash" aria-hidden="true"></i></button>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>
        <pagination-component :list-pagination="listPagination" @set-page="setPage"/>
    </div>
    <div v-else-if="listPending">
        <div class="text-center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                (načítám)
        </div>
    </div>
    <div v-else="">
        <div class="text-center">
            (nebyl nalezen žádný dokument)
        </div>
    </div>
  </div>
</template>

<script>
  import apiMixin from '@/mixins'
  import PaginationComponent from '@/components/PaginationComponent.vue'

  export default {
    data () {
      return {
        getParams: {
          p: 1,
          s: 'file_date-',
          f: {
          },
          pp: 20
        },
        setting: require('@/variables.js'),
        listData: false,
        listError: false,
        listPagination: null,
        listPending: false,
        // delete document
        documentDeletePending: false,
        documentDeleteDone: false,
        documentDeleteError: null
      }
    },
    props: ['reload'],
    mixins: [apiMixin],
    methods: {
      setPage (number) {
        this.getParams.p = number
        this.loadDocuments()
      },
      loadDocuments () {
        this.getDocuments(this.getParams)
      },
      clickDeleteDocument (id) {
        this.deleteDocument(id)
      }
    },
    beforeMount () {
      this.getParams.f = { 'visit': this.$route.params.visitid, 'client': this.$route.params.clientid }

      this.loadDocuments()
    },
    watch: {
      reload: function (val) {
        if (val === true) {
          this.loadDocuments()
        }
      },
      listPending: function (val, oldVal) {
        if (oldVal === true && val === false) {
          this.$emit('listReloaded')
        }
      },
      documentDeletePending: function (val, oldVal) {
        if (oldVal === true && val === false) {
          this.loadDocuments()
        }
      }
    },
    components: {
      PaginationComponent
      // TaskChangeDoctor,
      // TaskChangeState,
      // Datepicker
    },
    filters: {
      //
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

</style>



// WEBPACK FOOTER //
// src/views/Document/DocumentList.vue?b18b54d8